import Health from './health.component';

export default [{ path: '/health', name: 'health', component: Health, exact: true }];
